/* eslint-disable camelcase */
import React, { useMemo, useContext } from 'react';
import { isEmpty } from 'lodash';

export interface User {
  id: number;
  mem_id: number;
  avatar: string;
  name: string;
  position: string;
  company: string;
}

interface MyInfo {
  id: number;
  company: string;
  position: string;
  name: string;
  avatar: string;
  mem_id: number;
}

export const AuthContext = React.createContext<{ user: Partial<User>; isAuth: boolean }>(null);

export const AuthProvider: React.FC<{ children?: React.ReactNode; user: MyInfo }> = ({ children, user }) => {
  const userInfo = useMemo(() => {
    const isAuth = !isEmpty(user);
    const result = isAuth ? user : {};
    return { isAuth, user: result };
  }, [user]);

  return <AuthContext.Provider value={userInfo}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
